import EquipmentAddRuleForm from "./equipment-add-rule-form";

export default EquipmentAddRuleForm;